import React, { useEffect, useState } from "react";
import assetsCompareServices from "./assetsCompareServices";
import adminLogo from '../../../assets/images/logo.png';
import Pagination from "../../Header/Pagination";

export default function AdminAsset() {

    let [totalRows, setTotalRows] = useState(0);
    let [searchFor, setsearchFor] = useState("");
    var payLoad = { pageSize: 10,  pageNumber: 1  }
    let [fullAdminAssets, setFullAdminAssets] = useState<any>([]);
    let [rawAdminAssets, setRawAdminAssets] = useState<any>([]);
    let [selectionList, setSelectionList] = useState<any>([]);

    useEffect(() => {
        searchFor ="";
        setsearchFor(searchFor);
        getAssetCompareData();
    }, [])


    const getAssetCompareData = () => {
        var genPayload = {
            "CustomID": false,
            "RTitle": true,
            "TTitle": false,
            "RArtist": false,
            "TArtist": false,
            "ISRC": false,
            "catlogNum": true,
            "method": "adminDataOnly"
        }

        assetsCompareServices.getAssetCompare(genPayload).then((res) => {
            setRawAdminAssets(res?.adminAssets)
            setFullAdminAssets(res?.adminAssets.slice((payLoad.pageNumber - 1) * payLoad.pageSize, (payLoad.pageSize * payLoad.pageNumber)));
            totalRows = rawAdminAssets.length
            setTotalRows(totalRows);
        })

    }

    const exportAssetData = (type: any) => {
        var selectAsset: any = [];

        var exportPayload = {
            "CustomID": false,
            "RTitle": true,
            "TTitle": false,
            "RArtist": false,
            "TArtist": false,
            "ISRC": false,
            "catlogNum": true,
            "method": "adminDataOnly",
            "assetList": [],
            "ExportType": "adminDataOnly"
        }

        selectionList.forEach((element: any) => {
            selectAsset.push({ ISRC: element.ISRC, catalogNumber: element.CatalogNumber })
        });

        console.log(selectAsset)

        //build Selected Assets
        if (type.includes("Selected")) {
            exportPayload.assetList = selectAsset;
            console.log(exportPayload)
        }

        //build Selected Assets
        if (type.includes("_PA")) {
            console.log(exportPayload)

            assetsCompareServices.exportPhyAssetCompare(exportPayload)
        } else {
            assetsCompareServices.exportAssetCompare(exportPayload);
        }

    }

    const selection = (e: any) => {

        console.log(e)
        var checkList = selectionList.findIndex((list: any) => list.ISRC == e.ISRC && list.CatalogNumber == e.CatalogNumber)
        console.log(checkList)

        if (checkList === -1) {
            const newList = [...selectionList, e];
            selectionList = newList;
            setSelectionList(selectionList);
        } else {
            const newList = selectionList.filter((item: any, i: number) => i !== checkList);
            selectionList = newList
            setSelectionList(selectionList);
        }

        console.log(selectionList)

    }

    const paginationHandler = (e: any) => {
        payLoad.pageSize = e.pageSize;
        payLoad.pageNumber = e.pageNumber;        
        setFullAdminAssets(rawAdminAssets?.slice((payLoad.pageNumber - 1) * payLoad.pageSize, (payLoad.pageSize * payLoad.pageNumber)));
    }

    const searchSummary = (e: any) =>{
        searchFor= e
        setsearchFor(searchFor)
        console.log( e )

        if(searchFor.length > 0){
            const filterList = rawAdminAssets?.filter((item: any) => {
                const value = searchFor?.toLowerCase().trim();
                return (
                    item.Barcode?.toLowerCase().includes(value)         ||
                    item.CatalogNumber?.toLowerCase().includes(value)   ||
                    item.ReleaseLabel?.toLowerCase().includes(value)    ||
                    item.ReleaseTitle?.toLowerCase().includes(value)    ||
                    item.ReleaseArtist?.toLowerCase().includes(value)   ||
                    item.ISRC?.toLowerCase().includes(value)            ||
                    item.TrackName?.toLowerCase().includes(value)       ||
                    item.TrackLabel?.toLowerCase().includes(value)      || 
                    item.customID?.toLowerCase().includes(value)  
                );
            });
            console.log(filterList)
            totalRows = filterList.length
            console.log(filterList.length)
            setTotalRows(totalRows)
            fullAdminAssets = filterList;
            setFullAdminAssets(fullAdminAssets)
        }

        if(searchFor.length == 0){
            setFullAdminAssets(rawAdminAssets?.slice((payLoad.pageNumber - 1) * payLoad.pageSize, (payLoad.pageSize * payLoad.pageNumber)));
        }

    }


    return (<>
        <div className="landing ws-12">

            <div className="ws-12 pLarge">
                <div className="ws-12 ptxl mtl">
                    <span className="ws-12 text-bold text-xl">Asset Management</span>
                    <span className="ws-12 ptl text-bold text-m turquoise">Admin Assets</span>
                </div>

                <div className="ws-12 ptxl">

                    <div className="ws-12 mbl">
                        <button className="btn white pLarge bg-level14 m0 ws-2" onClick={() => searchSummary(searchFor)}> Search</button>
                        <input type="text" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} className="pLarge ws-10 m0 heightReset" placeholder="Type to search" />
                    </div>

                </div>


                <div className="ws-12 bgWhite mbl">
                    <div className="ws-12 box">

                        <div className="ws-12 pm">

                            <div className="verticalMediumWide hover-box pull-right forceSingleLine prl">
                                <a className="white ws-12 m0 bg-level7 pm  btn-m">Export Admin Assets </a>

                                <div className="hover-block mtlxl pt  box pm">
                                    <a className="btn-success btn-xs mt ws-10" onClick={() => exportAssetData("All_A")}>Export All Assets </a>
                                    <a className="btn-success btn-xs mt ws-10" onClick={() => exportAssetData("Selected_A")}>Export Selected Assets</a>

                                    <a className="btn-success btn-xs mt ws-10" onClick={() => exportAssetData("All_PA")}>Export All  physical Assets</a>
                                    <a className="btn-success btn-xs mt ws-10" onClick={() => exportAssetData("Selected_PA")}>Export Selected physical Assets</a>
                                </div>
                            </div>

                        </div>

                        <div className="ws-12 pm ptl pt pb">
                            <span className="text-bold text-m">Showing <span className="info">{totalRows}</span> results</span>
                        </div>

                        <div className='ws-12 mtl pLarge tableVertical'>
                            <table className={'tableVertical ws-12'}>
                                <thead>
                                    <tr>
                                        <th > </th>
                                        <th className="text-center">Release Code</th>
                                        <th className="text-center">Release Title</th>
                                        <th className="text-center">Release Artist</th>
                                        <th className="text-center">CustomID</th>
                                        <th className="text-center">ISRC</th>
                                        <th className="text-center">Track Title</th>
                                        <th className="text-center">Track Artist</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {fullAdminAssets?.map((list: any, index: any) => {
                                        return (<>
                                            <tr className={index % 2 === 0 ? 'bg-level8' : 'bg-red'}>
                                                <td width='8%' className='ptl pbl'>
                                                    <input className='mt mrl' type='checkbox' name={index} onClick={() => selection(list)} />
                                                    <img className="pull-none" src={adminLogo} width={40} />
                                                </td>
                                                <td width='13%'>{list?.CatalogNumber}</td>
                                                <td width='13%'>{list?.ReleaseTitle}</td>
                                                <td width='13%'>{list?.ReleaseArtist}</td>
                                                <td width='13%'>{list?.customID}</td>
                                                <td width='13%'>{list?.ISRC}</td>
                                                <td width='13%'>{list?.TrackName}</td>
                                                <td width='13%'>{list?.TrackArtist}</td>
                                            </tr>
                                        </>)
                                    })}
                                </tbody>
                            </table>

                            <div className="clearfix ws-12 pm">
                                {(() => {
                                    if (totalRows > 10) {
                                        return <Pagination onChange={paginationHandler} totalRows={totalRows} />
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </>)
}